import ReactOnRails from 'react-on-rails';

import Card from '../components/layout/Card';
import Header from '../components/layout/Header';
import HomeIndex from '../components/admin/Home/HomeIndex';
import LocationSwitcher from '../components/layout/LocationSwitcher';
import ProductForm from '../components/admin/Products/ProductForm';
import ProductsIndex from '../components/admin/Products/ProductsIndex';
import SubscriptionProductForm from '../components/admin/Products/SubscriptionProductForm';
import SearchResults from '../components/admin/SearchResults';
import Sidebar from '../components/layout/Sidebar';
import SignIn from '../components/sessions/SignIn';
import AccountCheck from '../components/sessions/AccountCheck';
import ForgotPassword from '../components/passwords/ForgotPassword';
import ForgotPasswordSuccess from '../components/passwords/ForgotPasswordSuccess';
import ResetPassword from '../components/passwords/ResetPassword';
import ResetPasswordSuccess from '../components/passwords/ResetPasswordSuccess';
import UserGeneralInfo from '../components/admin/Families/UserGeneralInfo';
import UsersIndex from '../components/admin/Families/UsersIndex';
import FamilyPage from '../components/admin/Families/FamilyPage';
import FamilyWizard from '../components/admin/Families/FamilyWizard';
import ImportCustomerWizard from '../components/admin/Families/ImportCustomer/ImportCustomerWizard';
import SendDocumentPage from '../components/admin/Families/SendDocumentPage';
import DogPage from '../components/admin/Dogs/DogPage';
import CheckInFlow from '../components/admin/CheckIn/CheckInFlow';
import CheckOutFlow from '../components/admin/CheckOut/CheckOutFlow';
import CheckOutStep from '../components/admin/CheckOut/CheckOutStep';
import TestComponent from '../components/TestComponent';
import CheckOutStepTest from '../components/admin/CheckOut/CheckOutStep';
import SearchStep from '../components/admin/CheckOut/SearchStep';
import ReviewStep from '../components/admin/CheckOut/ReviewStep';
import VisitsIndex from '../components/admin/Visits/VisitsIndex';
import SubscriptionsIndex from '../components/admin/Subscriptions/SubscriptionsIndex';
import SubscriptionShow from '../components/admin/Subscriptions/SubscriptionShow';
import PaymentsIndex from '../components/admin/Payments/PaymentsIndex';
import PaymentShow from '../components/admin/Payments/PaymentShow';
import GoodFitTestsIndex from '../components/admin/GoodFitTests/GoodFitTestsIndex';
import GoodFitTestWizard from '../components/admin/GoodFitTests/GoodFitTestWizard';
import Modal from '../components/layout/Modal';
import TrendsIndex from '../components/admin/Trends/TrendsIndex';
import MembershipInsightsIndex from '../components/admin/MembershipInsights/MembershipInsightsIndex';
import NotificationsIndex from '../components/admin/Notifications/NotificationsIndex';
import StripeWebhooksIndex from '../components/admin/StripeWebhooks/StripeWebhooksIndex';
import SettingsIndex from '../components/admin/Settings/SettingsIndex';
import ViewDocumentPage from '../components/admin/Families/ViewDocumentPage';
import SignAgreementsPage from '../components/member/SignAgreementsPage';
import MemberHomePage from '../components/member/MemberHomePage';
import MemberVisitsPage from '../components/member/MemberVisitsPage';
import MemberAccountPage from '../components/member/MemberAccountPage';
import FlashToastHost from '../components/layout/FlashToastHost';
import ActivitiesIndex from '../components/admin/Activities/ActivitiesIndex';
ReactOnRails.register({
  Card,
  Header,
  HomeIndex,
  LocationSwitcher,
  ProductForm,
  ProductsIndex,
  SubscriptionProductForm,
  SearchResults,
  Sidebar,
  SignIn,
  AccountCheck,
  ForgotPassword,
  ForgotPasswordSuccess,
  ResetPassword,
  ResetPasswordSuccess,
  UserGeneralInfo,
  UsersIndex,
  FamilyPage,
  FamilyWizard,
  ImportCustomerWizard,
  SendDocumentPage,
  DogPage,
  CheckInFlow,
  CheckOutFlow,
  CheckOutStep,
  TestComponent,
  CheckOutStepTest,
  SearchStep,
  ReviewStep,
  VisitsIndex,
  SubscriptionsIndex,
  SubscriptionShow,
  PaymentsIndex,
  PaymentShow,
  GoodFitTestsIndex,
  GoodFitTestWizard,
  Modal,
  TrendsIndex,
  MembershipInsightsIndex,
  NotificationsIndex,
  StripeWebhooksIndex,
  SettingsIndex,
  ViewDocumentPage,
  SignAgreementsPage,
  MemberHomePage,
  MemberVisitsPage,
  MemberAccountPage,
  ActivitiesIndex,
  FlashToastHost,
});